<template>
  <div class="draft">
    <template>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" forceRender>
          <span slot="tab">
            <a-icon type="smile" theme="twoTone" />
            每日动态
          </span>
          <Draftcolumn :message="tagmsg1" />
        </a-tab-pane>
        <!-- <a-tab-pane key="2" forceRender>
          <span slot="tab">
            <a-icon type="usb" theme="twoTone" />
            资源共享
          </span>
          <SendShare />
        </a-tab-pane> -->
        <a-tab-pane key="3">
          <span slot="tab">
            <a-icon type="bug" theme="twoTone" />
            <!-- <a-icon type="android" /> -->
            架构领域
          </span>
          <Draftcolumn :message="tagmsg2" />
        </a-tab-pane>
      </a-tabs>
    </template>
  </div>
</template>

<script>
import draftcolumn from "@/components/user/usercolumn/release/draftcolumn.vue";
export default {
  name: "draft",
  data() {
    return {
      discussion: "草稿列表",
      tagmsg1: 1,
      tagmsg2: 2,
    };
  },
  components: {
    Draftcolumn: draftcolumn,
  },
};
</script>

<style lang="less" scoped>
.draft {
  width: 100%;
  height: 500px;
  background-color: rgb(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/release/draft.vue